__webpack_require__.p = "/tokens-border-radius/onboarding/";